// Centralized configuration for frontend app
// All environment-dependent values should be defined here

/**
 * Default API base URL for local development
 * Overridden by VITE_API_BASE environment variable in CI/CD
 */
export const DEFAULT_API_BASE = '';


/**
 * Get the API base URL from environment or use default
 */
export const API_BASE = (import.meta as ImportMeta & { env?: { VITE_API_BASE?: string } }).env?.VITE_API_BASE || DEFAULT_API_BASE;

/**
 * Enable dev mode features (test cases, injectors) in preview and production
 * Set to false to disable dev mode completely
 */
export const DEV_MODE_ENABLED = true;
